import { FC } from 'react';
import { RescheduleRequestViewProvider } from '../../hooks/use-reschedule-request-view';
import { RescheduleRequestView } from './reschedule-request';

export interface RescheduleRequestViewWithProviderProps {
  apptRequestId: number;
}

export const RescheduleRequestViewWithProvider: FC<RescheduleRequestViewWithProviderProps> = (props) => {
  return (
    <RescheduleRequestViewProvider apptRequestId={props.apptRequestId}>
      <RescheduleRequestView />
    </RescheduleRequestViewProvider>
  );
};
